import { orderFragment } from '@/services/fragments'

export const listOrdersQuery = /* GraphQL */ `
  query ListOrders(
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrders(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        status
        type
        requestType
        shopID
        user {
          id
          name
        }
        createdAt
      }
      nextToken
    }
  }
`

export const ordersByTypeQuery = /* GraphQL */ `
  query OrdersByType(
    $type: String!
    $filter: ModelOrderFilterInput
    $orderUserId: ModelIDKeyConditionInput
    $limit: Int
    $nextToken: String
  ) {
    ordersByType(
      type: $type
      orderUserId: $orderUserId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        ...orderData
      }
      nextToken
    }
  }
  ${orderFragment}
`

export const ordersByShopQuery = /* GraphQL */ `
  query OrdersByShop(
    $shopID: ID!
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ordersByShop(
      createdAt: $createdAt
      filter: $filter
      shopID: $shopID
      sortDirection: DESC
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        ...orderData
      }
      nextToken
    }
  }
  ${orderFragment}
`

export const ordersByUserQuery = /* GraphQL */ `
  query OrdersByUser(
    $userID: ID!
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ordersByUser(
      createdAt: $createdAt
      orderUserId: $userID
      sortDirection: DESC
      limit: $limit
      nextToken: $nextToken
      filter: $filter
    ) {
      items {
        ...orderData
      }
      nextToken
    }
  }
  ${orderFragment}
`

export const ordersByToOrganizationQuery = /* GraphQL */ `
  query OrdersByToOrganization(
    $toOrganizationID: ID!
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ordersByToOrganization(
      createdAt: $createdAt
      toOrganizationID: $toOrganizationID
      sortDirection: DESC
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        ...orderData
      }
      nextToken
    }
  }
  ${orderFragment}
`

export const ordersByOrganizationQuery = /* GraphQL */ `
  query OrdersByOrganization(
    $organizationID: ID!
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ordersByOrganization(
      createdAt: $createdAt
      organizationID: $organizationID
      sortDirection: DESC
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        ...orderData
      }
      nextToken
    }
  }
  ${orderFragment}
`

export const ordersByManagerQuery = /* GraphQL */ `
  query OrdersByManager(
    $managerID: ID!
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ordersByManager(
      createdAt: $createdAt
      managerID: $managerID
      sortDirection: DESC
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        ...orderData
      }
      nextToken
    }
  }
  ${orderFragment}
`

export const ordersByToUserQuery = /* GraphQL */ `
  query OrdersByToUser(
    $toUserID: ID!
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ordersByToUser(
      createdAt: $createdAt
      toUserID: $toUserID
      sortDirection: DESC
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        ...orderData
      }
      nextToken
    }
  }
  ${orderFragment}
`

export const getOrderByIDQuery = /* GraphQL */ `
  query getOrderByID($orderID: ID!) {
    getOrder(id: $orderID) {
      ...orderData
    }
  }
  ${orderFragment}
`

// Canonical participants and scope used by Stream's existing access checks.
export const getStreamOrderAccessQuery = /* GraphQL */ `
  query StreamOrderAccess($orderID: ID!) {
    getOrder(id: $orderID) {
      id
      message
      items
      orderUserId
      toUserID
      organizationID
      toOrganizationID
      user {
        id
      }
      toUser {
        id
      }
      shop {
        organizationID
        contacts
        user {
          id
        }
      }
    }
  }
`
